import { render } from "./SocialCategory.vue?vue&type=template&id=11b93eab&scoped=true"
import script from "./SocialCategory.vue?vue&type=script&lang=js"
export * from "./SocialCategory.vue?vue&type=script&lang=js"

import "./SocialCategory.vue?vue&type=style&index=0&id=11b93eab&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b93eab"]])

export default __exports__